import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSlideData } from '@context/slide-data';
import { CreditorTable, SectionLabel, CreditUtilizationChart, InterestCalculatorTable } from '../shared';
import { SlideSection, SectionHeader } from '../styles';

const YourAnalysisStyle = styled.div`
    display: flex;
    ${props => props.desktop && props.english && 'height: 100%'};
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    >div {
        height: 100%;
    }
    >div:nth-of-type(2) {
        display: inherit;
        flex-direction: ${props => props.desktop ? 'row' : 'column'};
        justify-content: space-evenly;
        >div {
            display: inherit;
            flex-direction: column;
            width: 100%;
        }
    }
    @media (max-width: 550px) {
        >div {
            flex-direction: column;
            align-items: center;
        }
    }
`;

export const YourAnalysis = () => {
    const { t } = useTranslation();
    const { desktop, data, slideState, sectionsVisible } = useSlideData();
    const { language } = slideState;

    let selected = null;
    if (slideState.selectedSection) {
        selected = slideState.selectedSection[data.id];
    }

    const { avgMonthlyInterest, totalMonthlyInterest, remainingCredit,
        totalAnnualInterest, percentPaidInInterest, creditorData, 
        avgCreditUsage, creditRating, totalBalance, totalPayment } = data.details;

    const interestTableValues = [
        {
            label: 'avg_interest_rate',
            value: avgMonthlyInterest
        },
        {
            label: 'total_monthly_interest',
            value: totalMonthlyInterest
        },
        {
            label: 'total_annual_interest',
            value: totalAnnualInterest
        },
        {
            label: 'percent_paid_interest',
            value: percentPaidInInterest
        }
    ];

    return (
        <YourAnalysisStyle desktop={desktop} creditors={creditorData} english={language === 'English'}>
            <SlideSection
                selected={selected === 1}
                visible={sectionsVisible}>
                    <SectionLabel section={1} />
                    <CreditorTable
                        totalBalance={totalBalance}
                        totalPayment={totalPayment}
                        avgCreditUsage={avgCreditUsage}
                        creditorData={creditorData} />
            </SlideSection>
            <div>
                <SlideSection
                    selected={selected === 2}
                    visible={sectionsVisible}>
                        <SectionLabel section={2} />
                        <SectionHeader>{t('your_analysis.credit_utilization')}</SectionHeader>
                        <CreditUtilizationChart
                            remainingCredit={remainingCredit}
                            avgCreditUsage={avgCreditUsage}
                            creditRating={creditRating}/>
                </SlideSection>
                <SlideSection
                    selected={selected === 3}
                    visible={sectionsVisible}>  
                        <SectionLabel section={3} />
                        <SectionHeader>{t('your_analysis.interest_calculator')}</SectionHeader>
                        <InterestCalculatorTable isRebuttal={false} values={interestTableValues} />
                </SlideSection>
            </div>
        </YourAnalysisStyle>
    );
};

export default YourAnalysis;
